import React from 'react';
import styles from '../../../styles/HomeLanding/HomeLanding.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, FreeMode, Mousewheel, Pagination } from 'swiper';
import Image from 'next/image';
import useLazyInView from '@/hooks/useLazyInView';

const AwardsSection = () => {
   const [sectionRef, isInView] = useLazyInView('200px 0px');
   const AwardsandRecognitionData = [
      {
         img: "/assets/CIIFutureSites.png",
         altText: "CII Future Sites recognition",
         width: '31rem',
         height: '24rem',
      },
      {
         img: "/assets/HomeLanding/award-siliconIndia1.webp",
         altText: "software suggest",
         width: '31rem',
         height: '24rem',
      },
      {
         img: "/assets/HomeLanding/category_leader.webp",
         altText: "Category Leader",
         width: '31rem',
         height: '24rem',
      },
       {
         img: "/assets/HomeLanding/solutionProvider.webp",
         altText: "Solution Provider",
         width: '31rem',
         height: '24rem',
      },
       {
         img: "/assets/HomeLanding/FeatureSet.webp",
         altText: "Feature Set",
         width: '31rem',
         height: '24rem',
      },
      {
         img: "/assets/HomeLanding/award-mahakumbh1.webp",
         altText: "Maha-kumbh",
         width: '31rem',
         height: '24rem',
      },
      {
         img: "/assets/HomeLanding/IAAPI2.webp",
         altText: "Maha-kumbh",
         width: '31rem',
         height: '24rem',
      },
       
       
      // {
      //    img: "/assets/HomeLanding/EasyUsability.webp",
      //    altText: "Easy Usability",
      //    width: '31rem',
      //    height: '24rem',
      // },
      
      // {
      //    img: "/assets/HomeLanding/award-ffi1.webp",
      //    altText: "FFI",
      //    width: '31rem',
      //    height: '24rem',
      // },
       
      // {
      //    img: "/assets/HomeLanding/keka.webp",
      //    altText: "Keka",
      //    width: '31rem',
      //    height: '24rem',
      // },

   ];

   return (
      <div ref={sectionRef}>
         <div className={styles.awards_title}>
            <div className={styles.header}>Awards & Recognition</div>
            <h3 style={{fontSize:"2.8rem", fontFamily:"GilroyBold",margin:"1.5rem 0 1.5rem 0" }}>Global Recognition, Unmatched Excellence!</h3>
            <p>
               Our POS solution is not only empowering businesses but is also garnering global recognition with <br />its smarter operations and enhanced customer experiences. Trusted by businesses worldwide,we are <br />strongly committed to their excellence and growth.
            </p>
         </div>
         <div style={{ margin: '5rem 18rem', }}>
            <Swiper
               spaceBetween={40}
               slidesPerView={'auto'}
               centeredSlides={true}
               loop={true}
               loopAdditionalSlides={1}
               autoplay={{
                  delay: 10000,
                  disableOnInteraction: false,
               }}
               pagination={{ clickable: true, }}
               className="custom-features-swiper"
               watchSlidesProgress={true}
               speed={1000}
               modules={[Autoplay, Pagination, Mousewheel, FreeMode]}
               freeMode={true}
               mousewheel={{
                   forceToAxis: true,
                   invert: false,
                   sensitivity: 1,
               }}
               grabCursor={true}
            >
               {AwardsandRecognitionData.map((award, index) => (
                  <SwiperSlide
                     key={index}
                     style={{
                        width: award.width,
                        height: award.height,
                        flexShrink: 0  
                     }}
                  >
                     <div style={{
                        position: 'relative',
                        // width: award.width,
                        // height: award.height,
                        width:"100%",
                        height:"100%"
                        
                     }}>
                        {isInView && (
                           <Image
                              src={award.img}
                              alt={award.altText}
                              fill
                              loading="lazy"
                           />
                        )}
                     </div>
                  </SwiperSlide>
               ))}
            </Swiper>
         </div>
      </div>
   );
};

export default AwardsSection;
